<template>
  <div>
    <b-row class="mt-2">
      <b-col
        md="1"
        class="d-flex justify-content-center align-items-center"
      >
        <div
          style="cursor:pointer"
          @click="viewPic"
        >
          <b-spinner
            v-if="loadingPic"
            small
          />
          <b-avatar
            v-else
            :src="pic"
            variant="light-danger"
            size="50px"
          />

        </div>
      </b-col>
      <b-col md="4">
        <b-form-group
          label="Profile Picture"
          label-for="profile-picutre"
        >
          <b-form-file
            id="profile-picutre"
            v-model="file"
            accept="image/*"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          />
        </b-form-group>

      </b-col>
      <b-col md="4">
        <b-button
          class="mt-2"
          variant="primary"
          :disabled="!file || uploadingPic"
          @click="uploadPic"
        >
          Upload
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import {
  BFormGroup, BFormFile, BButton, BRow, BCol, BAvatar, BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BFormGroup, BFormFile, BButton, BRow, BCol, BAvatar, BSpinner,
  },
  setup(_, ctx) {
    const driverId = ctx.root.$route.params.id
    const file = ref(null)
    const pic = ref(null)
    const loadingPic = ref(false)
    const getDriverProfilePic = async () => {
      loadingPic.value = true
      const { url } = (await ctx.root.$store.dispatch('drivers/getProfilePicture', driverId)).data.data
      pic.value = url
      loadingPic.value = false
    }
    const uploadingPic = ref(false)
    const uploadPic = async () => {
      uploadingPic.value = true
      const { url } = (await ctx.root.$store.dispatch('drivers/getProfilePicPresignedURL', driverId)).data.data
      await ctx.root.$store.dispatch('documents/s3Upload', { url, file: file.value })
      uploadingPic.value = false
      getDriverProfilePic()
    }
    const viewPic = () => {
      if (pic.value) window.open(pic.value)
    }
    getDriverProfilePic()
    return {
      uploadingPic,
      uploadPic,
      file,
      pic,
      viewPic,
      loadingPic,
    }
  },
}
</script>
